import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {CurrencyFormatter, DateTimeFormatter} from "../../../utils/formatters";
import Select from "../../form/Select";
import {componentFilter} from "../../../utils/filters";

class MoneyTransferList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        let {view, componentConfig, filter, selection, selectionMode, onSelectionChange, className, showVisibleColumnFilter, isLoading, columnSort, onLoadCompleted, pageSize} = this.props;
        if (!filter) {
            filter = [];
        }
        if (this.props.moneyrepositoryType) {
            filter.push({field: "moneyrepository.component_type", value: this.props.moneyrepositoryType});
        }
        const props = {componentConfig, filter, loading: isLoading, pageSize: pageSize || 5, onLoadCompleted, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        let columns = {};
        if (this.props.moneyrepositoryType !== undefined) {
            columns = {
                [componentConfig.idfield]: {
                    header: 'Kód',
                    width: 1,
                    sortable,
                    filterable
                },
                "moneyrepository.name": {
                    header: this.props.moneyrepositoryType === 'BankAccount' ? 'Bankszámla' : 'Pénztár',
                    width: 2,
                    sortable,
                    filterField: "moneyrepository",
                    filterable: componentFilter({component: "MoneyRepository", props: {
                        filter: [{field: "component_type", value: this.props.moneyrepositoryType}]
                    }})
                },
                ...(this.props.moneyrepositoryType === 'BankAccount' ? {
                    "partnername": {header: 'Partner', width: 2, sortable, filterable},
                } : {}),
                "transferdate": {header: 'Időpont', width: 2, sortable, filterable},
                ...(this.props.moneyrepositoryType !== 'CashRepository' ? {
                    "direction": {
                        header: 'Irány',
                        width: 1,
                        sortable,
                        operator: "=",
                        filterable: <Select
                            storeType="local"
                            options={[
                                {key: "-1", label: "Kimenő"},
                                {key: "1", label: "Bejövő"}
                            ]}
                            label={false}
                            objectValue={false}
                            isClearable={true}
                            valueKey="key"
                            labelKey="label"
                        />,
                        renderer: (value) => value + "" === "1" ? "Bejövő" : "Kimenő"
                    }
                } : {}),
                "total": {header: 'Összeg', width: 2, sortable, filterable, renderer: CurrencyFormatter},
                ...(this.props.moneyrepositoryType === 'CashRepository' ? {
                    "comment.text": {header: 'Megjegyzés', width: 2, sortable, filterable},
                } : {}),
            };
        } else {
            props.namedFilters = false;
            columns = {
                [componentConfig.idfield]: {
                    header: 'Kód',
                    width: 2,
                    sortable,
                    filterable
                },
                "total": {
                    header: 'Összeg',
                    width: 6,
                    sortable,
                    filterable,
                    renderer: CurrencyFormatter
                },
                "transferdate": {
                    header: 'Dátum',
                    width: 4,
                    sortable,
                    filterable,
                    renderer: DateTimeFormatter
                },
            };
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "MoneyTransferList"}
                {...props}
                columnSort={columnSort}
                className={className}
                view={[componentConfig.idfield]}
                exports={[{as: "excel", label: "", icon: "far fa-file-excel"}]}
                aggregations={{
                    fields: {
                        "total_count": {
                            field: "total", type: "COUNT"
                        },
                        "total": {
                            field: "total", type: "SUM"
                        }
                    }
                }}
                columns={columns}
                showVisibleColumnFilter={showVisibleColumnFilter}
                orderBy={{field: "transferdate", direction: "DESC"}}
                selection={selection}
                selectionMode={selectionMode}
                onSelectionChange={onSelectionChange || ((selection) => this.props.loadForm(selection.value))}
            />
        );
    }
}

export default MoneyTransferList;
